import React from 'react';
import TailorYourForm from '../common/tailor-your-form';

export default class Step2 extends React.Component {

  render() {
    return <div className={this.props.className || ''}>
      <TailorYourForm />
    </div>
  }

}
